export const SIGNER_TYPES = {
  signer: 'signer',
  time: 'time',
  both: 'both',
  displaySign: 'displaySign',
}

export const SIGN_TYPES = {
  CIRCLE_SIGN: 'CIRCLE_SIGN',
  MAIN_SIGN: 'MAIN_SIGN',
  FLASH_SIGN: 'FLASH_SIGN',
  LOGO: 'LOGO',
}

export const getNumberFromArray = arr => {
  const hasSigner = arr.includes(SIGNER_TYPES.signer)
  const hasTime = arr.includes(SIGNER_TYPES.time)
  const hasBoth = arr.includes(SIGNER_TYPES.both)
  const hasDisplaySign = arr.includes(SIGNER_TYPES.displaySign)

  if (hasDisplaySign && (hasBoth || (hasSigner && hasTime))) return '6'
  if (hasDisplaySign && hasTime) return '5'
  if (hasDisplaySign && hasSigner) return '4'
  if (hasBoth || (hasSigner && hasTime)) return '3'
  if (hasTime) return '2'
  if (hasSigner) return '1'
  return '7'
}
